import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "empty", "chips", "routes", "routeCard", "cardBody", "chevron", "tripBody", "tripChevron"]

  connect() {
    this.currentDirection = "forward"
    this.currentDayType = this.isWeekendToday() ? "weekends" : "weekdays"
    this.updateEmptyState()
  }

  isWeekendToday() {
    const day = new Date().getDay()
    return day === 0 || day === 6
  }

  filter() {
    const query = this.searchTarget.value.trim().toLowerCase()
    let visibleCount = 0

    this.routeCardTargets.forEach(card => {
      const number = card.dataset.routeNumber.toLowerCase()
      const name = card.dataset.routeName.toLowerCase()
      const stops = card.dataset.stops.toLowerCase()
      const matches = number.includes(query) || name.includes(query) || stops.includes(query)

      if (matches) {
        card.classList.remove("hidden")
        visibleCount++
      } else {
        card.classList.add("hidden")
      }
    })

    if (visibleCount === 0) {
      this.emptyTarget.classList.remove("hidden")
    } else {
      this.emptyTarget.classList.add("hidden")
    }
  }

  jumpToRoute(event) {
    const number = event.currentTarget.dataset.routeNumber
    const card = this.routeCardTargets.find(c => c.dataset.routeNumber === number)
    if (!card) return

    this.openCard(card)
    card.scrollIntoView({ behavior: "smooth", block: "start" })
  }

  toggleCard(event) {
    const card = event.currentTarget.closest('[data-bus-schedule-target="routeCard"]')
    const body = card.querySelector('[data-bus-schedule-target="cardBody"]')
    const chevron = card.querySelector('[data-bus-schedule-target="chevron"]')
    const isOpen = !body.classList.contains("hidden")

    if (isOpen) {
      body.classList.add("hidden")
      chevron.classList.remove("rotate-180")
      event.currentTarget.setAttribute("aria-expanded", "false")
    } else {
      this.openCard(card)
    }
  }

  openCard(card) {
    const body = card.querySelector('[data-bus-schedule-target="cardBody"]')
    const chevron = card.querySelector('[data-bus-schedule-target="chevron"]')
    const trigger = card.querySelector('button[aria-expanded]')

    body.classList.remove("hidden")
    chevron.classList.add("rotate-180")
    if (trigger) trigger.setAttribute("aria-expanded", "true")

    // Ensure visible panel matches current direction/day
    this.syncCardVisibility(card)
  }

  setDirection(event) {
    this.currentDirection = event.currentTarget.dataset.direction

    // Update toggle buttons
    const group = event.currentTarget.closest('[role="group"]')
    group.querySelectorAll('button').forEach(btn => {
      const active = btn.dataset.direction === this.currentDirection
      btn.classList.toggle("bg-white", active)
      btn.classList.toggle("text-gray-900", active)
      btn.classList.toggle("shadow-sm", active)
      btn.classList.toggle("text-gray-500", !active)
      btn.setAttribute("aria-pressed", active)
    })

    this.routeCardTargets.forEach(card => this.syncCardVisibility(card))
  }

  setDayType(event) {
    this.currentDayType = event.currentTarget.dataset.dayType

    const group = event.currentTarget.closest('[role="group"]')
    group.querySelectorAll('button').forEach(btn => {
      const active = btn.dataset.dayType === this.currentDayType
      btn.classList.toggle("bg-white", active)
      btn.classList.toggle("text-gray-900", active)
      btn.classList.toggle("shadow-sm", active)
      btn.classList.toggle("text-gray-500", !active)
      btn.setAttribute("aria-pressed", active)
    })

    this.routeCardTargets.forEach(card => this.syncCardVisibility(card))
  }

  syncCardVisibility(card) {
    const panels = card.querySelectorAll('[data-direction][data-day-type]')
    panels.forEach(panel => {
      const matches = panel.dataset.direction === this.currentDirection && panel.dataset.dayType === this.currentDayType
      panel.classList.toggle("hidden", !matches)
    })
  }

  toggleTrip(event) {
    const button = event.currentTarget
    const tripContainer = button.closest('.rounded-lg')
    const body = tripContainer.querySelector('[data-bus-schedule-target="tripBody"]')
    const chevron = tripContainer.querySelector('[data-bus-schedule-target="tripChevron"]')
    const isOpen = !body.classList.contains("hidden")

    if (isOpen) {
      body.classList.add("hidden")
      chevron.classList.remove("rotate-180")
    } else {
      body.classList.remove("hidden")
      chevron.classList.add("rotate-180")
    }
  }

  updateEmptyState() {
    this.emptyTarget.classList.add("hidden")
  }
}
